import './single-product.scss';
export default (() => {
  // Make sure jQuery is defined before executing jQuery code
  if (document.querySelector('.single_add_to_cart_button')) {
    $('.single_add_to_cart_button').on('click', function (e) {
      var $thisbutton = $(this),
        $form = $thisbutton.closest('form.cart'),
        id = $thisbutton.val(),
        product_qty = $form.find('input[name=quantity]').val() || 1,
        product_id = $form.find('input[name=product_id]').val() || id,
        variation_id = $form.find('input[name=variation_id]').val() || 0;
      if ($form.hasClass('variations_form')) {
        return;
      } else {
        e.preventDefault();
      }
      if (typeof $form[0] !== 'undefined') {
        var formData = new FormData($form[0]); // Collect form data, including file inputs

        // Manually append any additional data required by your PHP function
        formData.append('action', 'lef_woocommerce_ajax_add_to_cart');
        formData.append('product_id', product_id);
        formData.append('product_sku', '');
        formData.append('quantity', product_qty);
        formData.append('variation_id', variation_id);

        // Send AJAX request with FormData
        $.ajax({
          type: 'POST',
          url: wc_object.ajax_url,
          data: formData,
          processData: false,
          // Prevent jQuery from automatically transforming the FormData object into a string
          contentType: false,
          // Prevent jQuery from overriding the `Content-Type` header
          beforeSend: function () {
            $thisbutton.removeClass('added').addClass('loading');
          },
          complete: function () {
            $thisbutton.removeClass('loading');
          },
          success: function (response) {
            if (response.error || response.product_url) {
              window.location = response.product_url;
              return;
            } else {
              // Success: You can optionally reload or update fragments
              $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
            }
          },
          error: function (xhr, status, error) {
            console.error('AJAX Error:', error);
            location.reload(); // Reload on error
          }
        });
      }
    });
  }
  if (document.querySelector('.single-product-gallery-holder')) {
    document.body.addEventListener("click", function (e) {
      if (e.target.matches(".gallery-control-buttons .control-button")) {
        e.preventDefault();
        var action = false;
        if (e.target.classList.contains("up")) {
          action = "prev";
        }
        if (e.target.classList.contains("down")) {
          action = "next";
        }
        var flexControlNav = document.querySelector(".flex-control-nav");
        var currentImage = flexControlNav.querySelector(".flex-active");
        var currentImageLi = currentImage.parentElement;
        var currentImageLiParent = currentImageLi.parentElement;
        var nextElement = false;
        if (action === "next") {
          if (currentImageLi.nextElementSibling) {
            nextElement = currentImageLi.nextElementSibling;
          } else {
            nextElement = currentImageLi.parentElement.firstElementChild;
          }
        } else if (action === "prev") {
          if (currentImageLi.previousElementSibling) {
            nextElement = currentImageLi.previousElementSibling;
          } else {
            nextElement = currentImageLi.parentElement.lastElementChild;
          }
        }
        if (nextElement) {
          nextElement.querySelector("img").click(); // Trigger click on the image

          var nextOffset = nextElement.getBoundingClientRect().top + window.scrollY; // Get the offset of the next element
          var currentImageLiParentOffset = currentImageLiParent.getBoundingClientRect().top + window.scrollY; // Get the offset of the current image's parent

          // Smooth scroll to the next element
          currentImageLiParent.scrollTo({
            top: nextOffset - currentImageLiParentOffset,
            behavior: "smooth"
          });
        }
      }
    });
    if (typeof $.fn.flexslider !== 'undefined') {
      $('.woocommerce-product-gallery').flexslider({
        slideshow: false // Disable the slideshow
      });
    }
  }
  $('body').on('click', '.variations_form .variations .variation-option', function (e) {
    e.preventDefault();
    var attribute = $(this).data('attribute');
    $(this).closest('.variation.' + attribute).find('.selected').removeClass('selected');
    $(this).addClass('selected');
    var option = $(this).data('option');
    var $select = $(this).closest('.variations_form').find('select#' + attribute);
    if ($select.length == 0) {
      // check based on name
      $select = $(this).closest('.variations_form').find('select[name="' + attribute + '"]');
      if ($select.length == 0) {
        // check based on name combination
        $select = $(this).closest('.variations_form').find('select[name="attribute_' + attribute.toLowerCase() + '"]');
      }
    }
    $select.val(option);
    $select.trigger('change');
  });

  // Initialize selected options based on the current select value
  document.querySelectorAll('.variations_form .variations select').forEach(function (select) {
    const value = select.value;
    const select_id = select.id;
    const option = select.closest('.variations').querySelector('.variation-option[data-attribute="' + select_id + '"][data-option="' + value + '"]');
    if (option) {
      option.classList.add('selected');
    }
  });
});